import i18n from "i18next";

export const changeLanguage = (language: "pl" | "en" = "pl") => {
    i18n.changeLanguage(language);
};
